import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/model";
import { StoreProvider } from "easy-peasy";
import "@splidejs/splide/dist/css/themes/splide-sea-green.min.css";
import "./firebaseui-styling.global.css";
import "./fonts/FredokaOne-Regular.ttf";
import "./fonts/Quicksand-SemiBold.ttf";
import "./fonts/SourceSansPro-Bold.ttf";
import { Helmet } from "react-helmet";
ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
